module.exports = __webpack_public_path__ + "img/scene2-4.ae2d4f58.jpg";